import React from 'react';
import { useSelector } from 'react-redux';

import { Info } from 'components/Alert/Info/Info';
import { FF_BANNER_COUPONS_CN } from 'constants/index';
import { usePeertransferFlags } from 'hooks/usePeertransferFlags/usePeertransferFlags';
import { ReactComponent as InfoIcon } from 'icons/ico-info-current-color.svg';
import { isPayingFromChina } from 'selectors';
import { useTranslations } from 'utils';

import './CouponBanner.scss';

const CouponBanner = () => {
  const i18n = useTranslations();
  const payingFromChina = useSelector(isPayingFromChina);

  const { data: featureFlags } = usePeertransferFlags([
    FF_BANNER_COUPONS_CN,
  ]);
  const isBannerCouponsEnabled = featureFlags?.[FF_BANNER_COUPONS_CN];

  if (!payingFromChina || !isBannerCouponsEnabled) {
    return null;
  }

  return (
    <Info className="CouponBanner" data-testid="CouponBanner">
      <InfoIcon />
      {i18n.t('coupon.banner.text')}
    </Info>
  );
};

export { CouponBanner };
